export const menuData = [
  { title: "Home", path: "/" },
  { title: "Portfolio", path: "/portfolio" },
  { title: "Wildlife", path: "/portfolio#wildlife" },
  { title: "Landscape", path: "/portfolio#landscape" },
  { title: "Architecture", path: "/portfolio#architecture" },
  { title: "Contact", path: "/portfolio#contact" },
]
